import ShoppinglistClient from './clients/ShoppinglistClient';

export default class ShoppinglistOverlayRows
{
    constructor(overlay)
    {
        // API
        this.shoppingListClient = new ShoppinglistClient();

        // Elements
        this.overlay = overlay;
        this.overlayAddProductsButton = this.overlay.querySelector('.js-overlay-shoppinglist-products-button');
        this.overlayAddListButton = this.overlay.querySelector('.js-overlay-shoppinglist-add-list-button');
        this.overlayNoList = this.overlay.querySelector('.js-overlay-shoppinglist--no-shoppinglists');

        // Templates
        this.defaultRowTemplate = this.overlay.querySelector('#shoppinglist-overlay-row-default');
        this.notDefaultRowTemplate = this.overlay.querySelector('#shoppinglist-overlay-row-not-default');

        // Selectors
        this.rowLabelSelector = '.js-overlay-shoppinglist-row-label';
        this.rowDateSelector = '.js-create-shoppinglist-date';
        this.rowQuantitySelector = '.js-shoppinglist-quantity';

        // Helper
        this.defaultShoppingList = document.querySelector('meta[name="default_shopping_list_id"]');
    }

    init()
    {
        this.shoppingListClient.fetchAllShoppinglists()
            .then((response) =>
            {
                if (response.ok)
                {
                    return response.json();
                }
            })
            .then((data) =>
            {
                this.renderShoppinglistRows(data.shoppingLists);
            })
            .catch(() =>
            {
                console.log('No shopping lists found!');
                this.overlayNoList.classList.remove('hidden');
                this.overlayAddListButton.classList.remove('hidden');
                this.overlayAddProductsButton.classList.add('hidden');
            });
    }

    renderShoppinglistRows(shoppinglists)
    {
        this.overlay.querySelector('.list-container').innerHTML = '';

        shoppinglists.forEach(shoppinglist =>
        {
            let clone;

            if (shoppinglist.isDefault)
            {
                clone = this.defaultRowTemplate.cloneNode(true);
                clone.querySelector('input[name=shoppinglist]').setAttribute('checked', 'true');
            }
            else
            {
                clone = this.notDefaultRowTemplate.cloneNode(true);
            }

            clone.querySelector('input').id = 'shoppinglist-' + shoppinglist.id;
            clone.querySelector('input').value = shoppinglist.id;

            clone.querySelector('label').htmlFor = 'shoppinglist-' + shoppinglist.id;
            clone.querySelector('label .label').innerHTML = shoppinglist.name;

            clone.querySelector(this.rowDateSelector).innerHTML = shoppinglist.dateCreated;
            clone.querySelector(this.rowQuantitySelector).innerHTML = shoppinglist.productItemCount;


            clone.classList.remove('hidden');

            this.overlay.querySelector('.list-container').append(clone);
        });
    }
}
